export function YearSelect({ year, setYear, payrollPeriod }) {
  const years = [...new Set(payrollPeriod.map(p => new Date(p.dateFrom).getFullYear()))]
    .sort((a, b) => b - a); 

  const handleSelectChange = (event) => {
    setYear(event.target.value);
  };

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={year}
        onChange={handleSelectChange}
        style={{ color: "rgb(104, 104, 104)" }}
      >
        <option value="">All</option>
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </div>
  );
};